import AsoHeader from "../../../components/Aso/Header";
import AsoEmpresaBeneficariosFinais from "../../../components/Aso/Register/AsoEmpresaBeneficiariosFinais";

const AsoRegistroBeneficiariosFinais = () => {
    return(
        <>
            <AsoHeader />
            <AsoEmpresaBeneficariosFinais />
        </>
    );
}

export default AsoRegistroBeneficiariosFinais;